import React from 'react'
import './What_You_Can_Find.css'

const What_You_Can_Find = () => {

const features = [
  { title: "Nearby Shops & Products", icon: "🛍️" },
  { title: "Local Service Professionals", icon: "🛠️" },
  { title: "Farmers & Local Markets", icon: "🌾" },
  { title: "Ambulance, Police & Emergency", icon: "🚑" },
  { title: "Government Offices & Departments", icon: "🏢" },
  { title: "Doctors, Lawyers & Civic Services", icon: "⚖️" },
  { title: "Journalists & Verified Media", icon: "📰" },
  { title: "Political Representatives", icon: "🏛️" },
  { title: "Gram Panchayat & City Members", icon: "👥" },
  { title: "Community Organizations", icon: "🤝" },
];

  return (
    <section className='What_You_Can_Find'>
        <div className='container'>
               <div className="section-header">
          <h2>What You Can Find</h2>
          <p>
           Everything Your City Offers
          </p>
        </div>

        <div className="features-grid">
          {features.map((item, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-icon">{item.icon}</div>
              <h5>{item.title}</h5>
            </div>
          ))}
        </div>
        </div>
    </section>
  )
}

export default What_You_Can_Find
